<template>

<com-content class="contact">
    
    <a :href="linkPhone" class="contact-item is-phone"><span>{{ page.contact_phone }}</span></a>
    <a :href="linkWebsite" target="_blank" class="contact-item is-website" v-if="page.business.website"><span>{{ page.contact_website }}</span></a>
    <a :href="linkAddress" target="_blank" class="contact-item is-address"><span>{{ page.contact_address}}</span></a>
    <a v-if="page.business.email" :href="linkEmail" class="contact-item is-email"><app-icon name="email" /><span>{{ page.contact_email}}</span></a>
    <a v-if="page.business.social.twitter" :href="page.business.social.twitter" target="_blank" class="contact-item is-social is-twitter"><app-icon name="twitter" /></a>
    <a v-if="page.business.social.facebook" :href="page.business.social.facebook" target="_blank" class="contact-item is-social is-facebook"><app-icon name="facebook" /></a>
    <a v-if="page.business.social.instagram" :href="page.business.social.instagram" target="_blank" class="contact-item is-social is-instagram"><app-icon name="instagram" /></a>
    <a v-if="page.business.social.linkedin" :href="page.business.social.linkedin" target="_blank" class="contact-item is-social is-linkedin"><app-icon name="linkedin" /></a>
	<a v-if="page.business.social.pinterest" :href="page.business.social.pinterest" target="_blank" class="contact-item is-social is-pinterest"><app-icon name="pinterest" /></a>
	<a v-if="page.business.social.tiktok" :href="page.business.social.tiktok" target="_blank" class="contact-item is-social is-tiktok"><app-icon name="tiktok" /></a>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
	},
	
	created: function() {

		document.title = [
			this.page.contact_meta_title,
			this.page.business.name,
			this.settings.meta_suffix
		].join(' | ')

	},

    computed: {

        address: function() {

            var address = []

            if (this.page.business.address.first) address.push(this.page.business.address.first)
            if (this.page.business.address.second) address.push(this.page.business.address.second)
            if (this.page.business.address.city) address.push(this.page.business.address.city)
            if (this.page.business.address.county) address.push(this.data.counties[this.page.business.address.county])
            if (this.page.business.address.postcode) address.push(this.page.business.address.postcode)

            return address.join(', ')

		},
		
		linkEmail: function() {

			return 'mailto:' + this.page.business.email

		},

        linkAddress: function() {

            return 'https://www.google.co.uk/maps/search/' + encodeURIComponent(this.address)
             
        },

        linkPhone: function() {

            return 'tel:' + this.page.business.phone.replace(' ', '')

        },

        linkWebsite: function() {

            return this.page.business.website

        }

    }

}

</script>

<style scoped>

.contact {
    padding: 20px 0px!important;
}

.is-mobile .contact {
    padding: 10px 0px!important;
}

.contact >>> .content-body {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.contact-item {
    width: 160px;
    height: 160px;
    border-radius: 4px;
    border: 1px solid var(--color-grey-light);
    margin: 20px;
    background-position: 50% 40px;
    transition: all 100ms linear;
    background-repeat: no-repeat;
}

.is-mobile .contact-item {
    width: 92px;
    height: 92px;
    margin: 4px;
    background-size: auto 32px;
    background-position: 50% 20px;
}

.contact-item.is-email {
    text-align: center;
    color: var(--color-blue-dark);
}

.contact-item.is-email >>> .icon {
	font-size: 64px;
	line-height: 140px;
}

.is-mobile .contact-item.is-email >>> .icon {
	font-size: 32px;
	line-height: 72px;
}

.contact-item.is-social {
    line-height: 160px;
    text-align: center;
    font-size: 64px;
    color: #fff;
}

.is-mobile .contact-item.is-social {
    font-size: 32px;
    line-height: 92px;
}

.contact-item.is-twitter {
    background-color: var(--color-brand-twitter);
}

.contact-item.is-facebook {
    background-color: var(--color-brand-facebook);
}

.contact-item.is-instagram {
    background-color: var(--color-brand-instagram);
}

.contact-item.is-linkedin {
    background-color: var(--color-brand-linkedin);
}

.contact-item.is-pinterest {
    background-color: var(--color-brand-pinterest);
}

.contact-item.is-tiktok {
    background-color: var(--color-brand-tiktok);
}

.is-desktop .contact-item:hover {
    border-color: var(--color-grey-highlight);
    transform: scale(1.05);
}

.contact-item span {
    display: block;
    padding: 10px 0px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    font-weight: 700;
    text-align: center;
    color: var(--color-blue-light);
    text-transform: uppercase;
}

.is-mobile .contact-item span {
    font-size: 12px;
    width: calc(100% - 8px);
    bottom: 4px;
    padding: 0px 4px;
}

.is-desktop .contact-item:hover span {
    color: var(--color-blue-dark);
}

.contact-item.is-phone {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA7CAMAAADy+wKBAAAAeFBMVEUAAAAArdEiMF4gMGAjLlwDnMIjLVwKfqckLVwUX4ojLV0hNmUgK1ojLV0ZUHsFi7IkLlwiLl0jLl0gKFgkLFwkLVwcQnAOcZwdQnEaSnUXVoIjLVwhM2EhM2EfO2gjLlwfOmkkLV0hNWQdP2sRZ5IfPGokLlwkLl3iYpDoAAAAJ3RSTlMATvEQ8FWgY9B+YNMwsJRdgHDgIEDAq2yqn4hQ4uHEkMWP4bd11H9lsmhlAAACIElEQVRIx52X25KqMBBFCSQg97soKOrMnNP//4dDEkwQDKZnPVlWrUr3Nt2Co/AeFdB0cP5ASUHgo02vhSc3pNpQ0ES4eoXj9iRwAYAmCNUX6p0RIuXKQ6oZEYT8c4sq2O3IzBmRl8djugREcbfPq+Sn5kTDLtZ5paJXBSqvCgD0sTqvwsKFCbLiyKvGuRpedW1XM1u7XwDQfHb5EHTkTcMWYd1Ezls1teh3AID4RT0BJ7Fwa5jIN2rk2F6O46pg2jhWRPxS6qSvqAmmL2nJXm0p5mnQLmLP0WXHFxkUavq7xexXVpq+l19zXLkcImsamDirIUKl5fiLqpnYsx4mLv0j/8DEwcNVPaqqcf9LN1jckBgpH2AinFtGyrVoOVB5oeQEFncz2Mr1o23TaGegIGZPeZV2BIIqMeW1lRM9MBIa7VyRf2wZGB3mUzWP91dEhH0iSxnSWi41cMPuDLITC/kI0v6vfoNQdEKTzzLpXVCEMoaLXIVmeWSzHNy1KmHyG98ky7QlYSx7JYqzvUzyPgv1AldNF2b5GhAjsumdtN3OLDPXuBG9FDi9SZU9F7vPXCdmco8mV1/CODA0vL8PByqafl/3+GGJJwfgjPlWzWBi2F2esmk3W6udzXNBRIV9/XlRc7sFXrcgGEOp6dFsEK8R1/65yYRa2u1P3rXUv7Ms+8a9kNQprGgdexKfKg//GuSV6vBD4+BpyqIoytpR/ALXb2UeAb/MPAAAAABJRU5ErkJggg==);
}

.contact-item.is-website {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAA/CAMAAACM9IX7AAAARVBMVEUArdMAAAAkLVwcS3cTaJUkLlwkLFwjLV0gMGAjLlwkLVwjLVwjLl0jLVwgKVkeQG4jLV0kLlwhOWcjLVwZUX4jLlskLl0xl4opAAAAFnRSTlNLAMCleIBAYBDw0FDgoCW8sH/Sr5pfLT5PvQAAAMJJREFUWMPt18sKgzAQheGc1FyMt9pL3v9RiyOkG1PCjBRa5tvo6scYCBMD4HnPTP00AzCINkuErWGzzAATslAfzXV7DJ7H0WrM/jlM9CMcNZLlGktDoDQeHddSGp3humhDG9rQhja0oY0faywXrltpCJw6S3lwub9sSGfcfdaO4JhXmrXPmPnld48Ag5jkdyAgJOldrIp2/b2DOKaNrzX8ZDd0OpWTZqS3NbY1Yp/rpraGzx+kxrWkXOcaGzG4Go8DL9qHZqg+dOsQAAAAAElFTkSuQmCC);
}

.contact-item.is-address {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABCCAMAAADwk38aAAAAYFBMVEUAAAAArdMgMGAjLl0kLlwkLFwkLV0jLlwgKFgiLl0gK1ojLV0jLVwkLVwjLV0kLVwjLlwjLV0jLVwcSnchNWMiMmATZpEfO2odRXIGlL4XVoMiLlwOdJ4LgaskLV0kLl3k70lIAAAAH3RSTlMASxDwgEDA4CBwMLBQ0GC/kJ+gpd7pe8ewVo5vbGGP3Ti/xQAAAjFJREFUSMeVVdl26yAMJCwGr3hr2t72Nv//ly1LLWFh5XReYuSxJDQDEQSd7v3jB8ovH514ArOoB4b9chzbPyh6c8F2iU2xyBp9+u2k0cZI4cygmxxRlRJLJk84mWxtCn+c2LKP4dHQsjb1VEYTvRUVyDl9QJpReNp0ZxMKxF6uxeniB8d7pyB7HV3UTuaVh68JcAc6q3qxVToQd6QfS1/oxS+6qChDz+uR3tSEtgOK6hAJO1iDqijRWHeOVLnr8DtV6WWfc1qaXCcj0V+3bdtPsnaJqIt22hDc/98C7i/lzoKRBtHDYHNz+/st4T2s/PFujcwG5xhCxpg9VchDhwmtIteE0OsN8IKVHGLneLux2Ib4b7hZc/AF5t8Rf6N8hfvpn+dv2P6xllPiQyiL93nQ/+XNQTIdpzqDJnj+nwprGTO3cUq2PBf7PWVXpb4qnioJhwsuin3b3kLvqHRMrLLD9JU/e1HYoc8WUxLfXID5dMCm3wctAIPN7MaczpdNhXIBgGv1rCdXhOIFAY+r4OFRUp3mxqHFN6K0cHvVIUvlBmiOua06sqag+aDeSIm433I/3B06wzwK8ylXpRtQ+qSHr/LHs54gwkDI9AVNQwv3V22udSM4bgxPB8fYwoEReBl54elb3ljUFrC2z2zeshOo2YIxAmcLMi9WfWoE3l1dxQicLTzxE3c6qBH409cRI/CnW8FfKYCzBTUCawt6X7C2IEbg0RAj8HD20UjxF1yN5hsC+V2GWi26XgAAAABJRU5ErkJggg==);
}

</style>